import "./footer.scss";

function Footer() {
  return (
    <footer className="holidaze-footer">
      <div className="container">
        <div className="footer-content">
          <p className="footer-logo">Holidaze</p>

          <p className="footer-text">
            Find and book unique venues for your next holiday.
          </p>

          <p className="copyright">© 2026 Holidaze</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
